<template>
  <div>
    <AccountStatusComponent />
  </div>
</template>

<script>
import AccountStatusComponent from './components/Index.vue'

export default {
  name: 'AccountStatus',
  components: {
    AccountStatusComponent,
  },
}
</script>
